'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIList = require('../list/UIList');

var _UIList2 = _interopRequireDefault(_UIList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Group clusters of Radio/Checkbox Buttons together, with common styling
 **/
exports.default = _react2.default.createClass({
  displayName: 'UIToggleGroup',

  propTypes: {
    children: _react2.default.PropTypes.node.isRequired,
    className: _react2.default.PropTypes.string,
    name: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    /* eslint-disable react/prop-types */
    var _props = this.props,
        children = _props.children,
        __error = _props.error,
        name = _props.name,
        rest = _objectWithoutProperties(_props, ['children', 'error', 'name']);

    return _react2.default.createElement(
      _UIList2.default,
      rest,
      _react2.default.Children.map(children, function (child) {
        var clone = _react2.default.cloneElement(child, _extends({ name: name }, child.props));
        return clone;
      })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/input/UIToggleGroup.js
// module id = 370
// module chunks = 0